import { useEffect, useState, useCallback } from 'react';
import { apiCall } from '../utils/api';

/**
 * Polls /api/hub/conversations for the unread message count so the
 * Messages icons (header + taskbar tabs) can render a live badge.
 * Returns { unread, refresh } so callers can force a refresh after
 * sending/marking-read.
 */
export default function useUnreadMessages(intervalMs = 20000) {
  const [unread, setUnread] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const res = await apiCall('/api/hub/conversations');
      const total =
        typeof res?.unread_count === 'number'
          ? res.unread_count
          : (res?.conversations || []).reduce(
              (acc, c) => acc + (c.unread_count || 0),
              0
            );
      setUnread(total);
    } catch {
      // Silent — keep last known value
    }
  }, []);

  useEffect(() => {
    refresh();
    if (!intervalMs) return undefined;
    const t = setInterval(refresh, intervalMs);
    return () => clearInterval(t);
  }, [refresh, intervalMs]);

  return { unread, refresh };
}
